
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency = "USD", options = {}): string {
  const defaultOptions = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  const mergedOptions = { ...defaultOptions, ...options };

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    ...mergedOptions
  }).format(amount);
}

// Generate a unique ID (useful for temporary keys)
export function uniqueId(prefix = 'id'): string {
  return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
}

// Format date in a friendly way
export function formatDate(date: Date | string): string {
  if (!date) return '';
  
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
}

// Get initials from a name
export function getInitials(name: string): string {
  if (!name) return '';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

// Safely truncate text with ellipsis
export function truncate(str: string, length: number): string {
  if (!str) return '';
  return str.length > length ? `${str.substring(0, length)}...` : str;
}
